import { formatNumber } from "util/format"

import Big from "big.js"
import { APR_PRECISION } from "constant/number"
import { useVirtualTickerSymbolFromRouterParams } from "hook/useRouterParams"

import { LiquidityProvider } from "../container/liquidityProvider"

// NOTE: disable reward related info for now
export function useLiquidityProviderData() {
    const marketSymbol = useVirtualTickerSymbolFromRouterParams()
    const { getMakerMarket, getDefaultMarket } = LiquidityProvider.useContainer()
    const makerMarket = getMakerMarket(marketSymbol)
    const defaultMarket = getDefaultMarket(marketSymbol)
    let baseAprStr = "--%"
    let rewardsAprStr = "--%"

    // TODO: need review
    // --------------------------------------------------
    let personalBaseAprStr = "--%"
    let personalRewardsAprStr = "--%"
    let personalTotalAprStr = "--%"
    let personalTotalAprVal = "0"

    let marketBaseAprStr = "--% - --%"
    let marketRewardsAprStr = "--% - --%"
    let marketTotalAprStr = "--% - --%"
    let marketTotalLowerAprStr = "--%"
    let marketTotalUpperAprStr = "--%"
    let marketTotalLowerAprVal = "0"
    let marketTotalUpperAprVal = "0"

    // --------------------------------------------------

    if (makerMarket) {
        baseAprStr = `${formatNumber(new Big(makerMarket.baseApr), APR_PRECISION)}%`
        // rewardsAprStr = `${formatNumber(new Big(makerMarket.rewardApr + makerMarket.rewardOpApr), APR_PRECISION)}%`
        rewardsAprStr = `${formatNumber(new Big(0), APR_PRECISION)}%`

        // --------------------------------------------------
        personalBaseAprStr = baseAprStr
        personalRewardsAprStr = rewardsAprStr
        // --------------------------------------------------

        // sum of makerMarket.baseApr and makerMarket.rewardApr

        // NOTE: disable reward info for now
        // personalTotalAprStr = `${formatNumber(
        //     new Big(makerMarket.baseApr).plus(makerMarket.rewardApr).plus(makerMarket.rewardOpApr),
        //     1,
        // )}%`
        // personalTotalAprVal = new Big(makerMarket.baseApr)
        //     .plus(makerMarket.rewardApr)
        //     .plus(makerMarket.rewardOpApr)
        //     .toString()
        personalTotalAprStr = `${formatNumber(new Big(makerMarket.baseApr), 1)}%`
        personalTotalAprVal = new Big(makerMarket.baseApr).toString()
    }
    if (defaultMarket) {
        baseAprStr = `${formatNumber(new Big(defaultMarket.lowerBaseApr), APR_PRECISION)}% - ${formatNumber(
            new Big(defaultMarket.upperBaseApr),
            APR_PRECISION,
        )}%`
        // rewardsAprStr = `${formatNumber(
        //     new Big(defaultMarket.lowerRewardApr).plus(defaultMarket.lowerRewardOpApr),
        //     APR_PRECISION,
        // )}% - ${formatNumber(
        //     new Big(defaultMarket.upperRewardApr).plus(defaultMarket.upperRewardOpApr),
        //     APR_PRECISION,
        // )}%`
        rewardsAprStr = `${formatNumber(new Big(0), APR_PRECISION)}%`
    }

    // --------------------------------------------------

    marketBaseAprStr = defaultMarket
        ? `${formatNumber(new Big(defaultMarket.lowerBaseApr), APR_PRECISION)}% - ${formatNumber(
              new Big(defaultMarket.upperBaseApr),
              APR_PRECISION,
          )}%`
        : "--% — --%"

    // marketRewardsAprStr = defaultMarket
    //     ? `${formatNumber(
    //         new Big(defaultMarket.lowerRewardApr).plus(defaultMarket.lowerRewardOpApr),
    //         APR_PRECISION,
    //     )}% - ${formatNumber(
    //         new Big(defaultMarket.upperRewardApr).plus(defaultMarket.upperRewardOpApr),
    //         APR_PRECISION,
    //     )}%`
    //     : "--% — --%"
    marketRewardsAprStr = `${formatNumber(new Big(0), APR_PRECISION)}%`

    // sum of marketBaseAprStr and marketRewardsAprStr

    // marketTotalAprStr = defaultMarket
    //     ? `${formatNumber(
    //         new Big(defaultMarket.lowerBaseApr)
    //             .plus(defaultMarket.lowerRewardApr)
    //             .plus(defaultMarket.lowerRewardOpApr),
    //         APR_PRECISION,
    //     )}% - ${formatNumber(
    //         new Big(defaultMarket.upperBaseApr)
    //             .plus(defaultMarket.upperRewardApr)
    //             .plus(defaultMarket.upperRewardOpApr),
    //         APR_PRECISION,
    //     )}%`
    //     : "--% — --%"
    marketTotalAprStr = defaultMarket
        ? `${formatNumber(new Big(defaultMarket.lowerBaseApr), APR_PRECISION)}% - ${formatNumber(
              new Big(defaultMarket.upperBaseApr),
              APR_PRECISION,
          )}%`
        : "--% — --%"

    // --------------------------------------------------

    // marketTotalApr upper and lower string

    // marketTotalLowerAprStr = defaultMarket
    //     ? `${formatNumber(new Big(defaultMarket.lowerBaseApr).plus(defaultMarket.lowerRewardApr), APR_PRECISION)}%`
    //     : "--%"
    marketTotalLowerAprStr = defaultMarket
        ? `${formatNumber(new Big(defaultMarket.lowerBaseApr), APR_PRECISION)}%`
        : "--%"
    // marketTotalLowerAprVal = defaultMarket
    //     ? new Big(defaultMarket.lowerBaseApr)
    //         .plus(defaultMarket.lowerRewardApr)
    //         .plus(defaultMarket.lowerRewardOpApr)
    //         .toString()
    //     : "0"
    marketTotalLowerAprVal = defaultMarket ? new Big(defaultMarket.lowerBaseApr).toString() : "0"

    // marketTotalUpperAprStr = defaultMarket
    //     ? `${formatNumber(
    //         new Big(defaultMarket.upperBaseApr)
    //             .plus(defaultMarket.upperRewardApr)
    //             .plus(defaultMarket.upperRewardOpApr),
    //         APR_PRECISION,
    //     )}%`
    //     : "--%"
    marketTotalUpperAprStr = defaultMarket
        ? `${formatNumber(new Big(defaultMarket.upperBaseApr), APR_PRECISION)}%`
        : "--%"

    // marketTotalUpperAprVal = defaultMarket
    //     ? new Big(defaultMarket.upperBaseApr).plus(defaultMarket.upperRewardApr).toString()
    //     : "0"
    marketTotalUpperAprVal = defaultMarket ? new Big(defaultMarket.upperBaseApr).toString() : "0"

    return {
        baseAprStr,
        rewardsAprStr,
        personalBaseAprStr,
        personalRewardsAprStr,
        personalTotalAprStr,
        marketBaseAprStr,
        marketRewardsAprStr,
        marketTotalAprStr,
        marketTotalLowerAprStr,
        marketTotalUpperAprStr,
        personalTotalAprVal,
        marketTotalLowerAprVal,
        marketTotalUpperAprVal,
    }
}
